module.exports = __webpack_public_path__ + "img/emsFA2.a653dbe6.png";